import { render, staticRenderFns } from "./MStoreDeleteConfirmationModal.vue?vue&type=template&id=fba8c50e&"
import script from "./MStoreDeleteConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./MStoreDeleteConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports